import { useContext, useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { TbWorld } from 'react-icons/tb';
import { JsxElement } from 'typescript';
import AppPropsContext from '../../context/appPropsContext';
import LoginContext, { ILanguage } from '../../context/loginContext';
import { useLanguage } from '../../hooks/useLanguage';
import StyledButton from '../Buttons/StyledButton';

const LanguageSwitch = () => {
    const [allLanguages, setAllLanguages] = useState<JsxElement[]>([]);
    const { t } = useLanguage();

    const { state } = useContext(LoginContext);
    const { apstate } = useContext(AppPropsContext);
    const { setActiveLanguage, getAvailableLanguages } = useLanguage();

    useEffect(() => {
        getDropdownItems();
    }, [state.activeLanguage, apstate.availableLanguages]);

    const handleLanguageSwitch = async (e: any, language: ILanguage) => {
        if (e && e.currentTarget) {
            e.preventDefault();
            e.currentTarget.blur();
        }
        setActiveLanguage(language);
    };

    const getDropdownItems = () => {
        const allItems: any[] = [];
        const availableLanguages = getAvailableLanguages();

        if (Array.isArray(availableLanguages) && availableLanguages.length) {
            availableLanguages.forEach((language: ILanguage) => {
                allItems.push(
                    <Dropdown.Item
                        key={language.id}
                        onClick={(e) => handleLanguageSwitch(e, language)}
                        label={language.name}
                    >
                        {language.name}
                    </Dropdown.Item>,
                );
            });
        }

        setAllLanguages(allItems);
    };

    // TODO Drodown.Toggle.aria-label intl-en
    return (
        <Dropdown id="language-dropdown" style={{ visibility: allLanguages?.length > 1 ? 'visible' : 'hidden' }}>
            {/* <label htmlFor="language-dropdown" className="sr-only">
            </label> */}
            <label htmlFor="language-dropdown-toggle" className="sr-only">
                {t('LOGIN', 'Sprachauswahl. Zur Zeit ausgewählt: Deutsch')}
            </label>
            <Dropdown.Toggle as={StyledButton} variant="secondary" margintop="1px" id="language-dropdown-toggle">
                <Badge>
                    <TbWorld size={20} />
                </Badge>
                <span aria-label={state.activeLanguage.language.name}>{state.activeLanguage.language.id}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu aria-labelledby="language-dropdown-toggle">{allLanguages}</Dropdown.Menu>
        </Dropdown>
    );
};

export default LanguageSwitch;
